import { colors } from '@opallabs/spectrum'

const contentHeight = 667
const contentWidth = 375
const placeholderIconSize = 85
const inputBackground = 'rgba(0, 0, 0, 0.75)'

const editorRoot = () => ({
  backgroundColor: inputBackground,
  borderRadius: 0,
  bottom: 175,
  color: colors.white.base,
  padding: '0',
  position: 'relative',
  zIndex: 1000,

  '&:hover': {
    backgroundColor: inputBackground,
  },
})

const inputPlaceholder = {
  color: colors.n6.base,
  padding: '0 5px',
}

const input = {
  padding: '0 5px',
}

const emptyState = (empty) => {
  if (empty) {
    return {
      '.kuiper-icon-wrapper': {
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        '.kuiper-icon-channel-snapchat': {
          color: colors.n8.base,
          fill: colors.n8.base,
          height: placeholderIconSize,
          width: placeholderIconSize,
        },
      },
    }
  }

  return {
    '.kuiper-asset-base': {
      height: '100%',
      width: '100%',
    },
  }
}

const base = ({ empty }) => ({
  backgroundColor: colors.white.base,
  height: contentHeight,
  position: 'relative',
  width: contentWidth,
  ...emptyState(empty),
})

export const styles = {
  base,
  input,
  editorRoot,
  inputPlaceholder,
}
